import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-04/lesson-05/task-01";

const task: Slide = {
  title: `In the case of a large tube opening into a small tube, the dominant effect is:`,
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
